import { Api } from "@/api";
import { UserLoginType } from "@/DTO";

export const CreateRole = (user: UserLoginType, title: string, permission_list: string[]) => {
  return new Promise<{
    data: any
  }>((resolve, reject) => {
    const api = new Api({
      method: "post",
      path: `role`,
      body: JSON.stringify(
        {
          title: title,
          permission_list: permission_list
        }
      ),
      header: {
        Authorization: "Bearer " + user.accessToken,
        "Content-Type": "application/json"
      }
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: data.data
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};